document.addEventListener('DOMContentLoaded', function () {
  var btn = document.querySelector('.menu-toggle');
  var nav = document.querySelector('.mobile-nav');
  if (btn && nav) {
    btn.addEventListener('click', function () {
      nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', nav.classList.contains('is-open') ? 'true' : 'false');
    });
  }
});
